import styled from "styled-components";
import { Breadcrumb } from "antd";

const StyledBreadcrumb = styled(Breadcrumb)`
  .ant-breadcrumb-link {
    color: #a5a3a3;

    &.active {
      color: #1e1919;
    }
  }
`;

export default StyledBreadcrumb;
